 <template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-format-list-bulleted</v-icon>
        <v-toolbar-title>{{ filterTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex md6 xs6>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-flex>
            <!-- TODO: To add delete all filters
            <v-flex md6 xs6 right>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark small color="error" v-on="on" @click.native="doPromptRemove">
                  <v-icon dark>mdi-minus-circle</v-icon>
                </v-btn>
              </template>
              <span>Delete All Filters</span>
            </v-tooltip>
          </v-flex> -->
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="name"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td class="text-xs-left">{{ row.item.filterName }}</td>
                    <td class="text-xs-left">{{ row.item.filterDesc }}</td>
                    <td class="text-xs-left">{{ row.item.activeFlag ? 'Yes' : 'No' }}</td>
                    <td class="table-action-header">
                      <table-action
                        :rowData="row"
                        review
                        @review="doReview(row.item)"
                        custom
                        customIcon="mdi-check"
                        customText="Apply"
                        @custom="applyDefaultFilter(row.item)"
                        remove
                        @remove="doPromptRemove(row.item)"
                      ></table-action>
                    </td></tr
                ></template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-dialog v-model="saveFilter" width="800px" persistent>
            <UpdateSearchFilter
              :boolRefresh="saveFilter"
              :dialogTitle="'Filter'"
              :filterName="selectedFilter.filterName"
              :actionName="'review'"
              :filterDesc="selectedFilter.filterDesc"
              :activeFlag="selectedFilter.activeFlag"
              @close="saveFilter = false"
              :filterCode="selectedFilter.filterCode"
              @refreshList="fetchList"
            ></UpdateSearchFilter>
          </v-dialog>
        </v-container>
      </v-card-text>
    </v-card>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected filter?</p>
      <div class="queryValue">{{ selectedFilter.filterName }}</div>
    </confirm>
  </div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'

export default {
  data() {
    return {
      saveFilter: false,
      selectedFilter: {
        filterCode: '',
        filterName: '',
        filterDesc: '',
        activeFlag: false
      },
      promptRemove: false,
      items: [],
      headers: [
        { text: 'Name', value: 'filterName' },
        { text: 'Description', value: 'filterDesc' },
        { text: 'Set as default', value: 'activeFlag' },
        TableConst.tableActionHeader
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.fetchList()
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    applyDefaultFilter(filterData) {
      this.$emit('applyDefaultFilter', filterData)
      this.closeDialog()
    },
    async doPromptRemove(filterData) {
      this.setFilterData(filterData)
      this.promptRemove = true
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedFilter.filterName) {
        const apiURI = this.$store.state.searchFilter.menu.deleteFilter
        if (apiURI) {
          const expand = {
            filterName: this.selectedFilter.filterName,
            filterCode: this.selectedFilter.filterCode
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchList()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doReview(filterData) {
      this.setFilterData(filterData)
      this.saveFilter = true
    },
    setFilterData(filterData) {
      this.selectedFilter.filterName = filterData.filterName
      this.selectedFilter.filterCode = filterData.filterCode
      this.selectedFilter.filterDesc = filterData.filterDesc
      this.selectedFilter.activeFlag = filterData.activeFlag
    },
    async fetchList() {
      this.saveFilter = false
      const apiUrl = this.$store.state.searchFilter.menu.searchFilterList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.items = []
          if (data) {
            data.map((resData) => {
              const itemsFilter = {
                activeFlag: resData.activeFlag,
                filterName: resData.filterName,
                filterDesc: resData.filterDesc,
                filterCode: resData.filterCode,
                filters: JSON.parse(resData.filterContent)
              }
              this.items.push(itemsFilter)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {},
  props: {
    filterCode: {
      type: String,
      default: ''
    },
    filterTitle: {
      type: String,
      default: ''
    },
    actionName: {
      type: String,
      default: ''
    },
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  components: {
    UpdateSearchFilter
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
